import * as React from 'react';
import { makeStyles, createStyles, StepIconProps, Box } from '@material-ui/core';
import { CheckRounded as CheckRoundedIcon } from '@material-ui/icons';
import cn from 'classnames';
import { TranquiTheme } from '../../containers/App/theme';

const CustomStepIcon: React.FC<StepIconProps> = (props) => {
  const { active, completed, icon } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <Box
      className={cn(classes.root, active && classes.active, completed && classes.completed)}
      data-test="cy-StepIcon-box"
    >
      {
        completed
          ? <CheckRoundedIcon className={classes.completedIcon} />
          : icon
      }
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    width: '1em',
    height: '1em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    fontSize: '1rem',
    backgroundColor: theme.palette.bg1.default,
    color: theme.palette.pearl.main,
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.pearl.main,
  },
  completed: {
    backgroundColor: theme.palette.pearl.main,
    color: theme.palette.primary.main,
    border: `solid 1px ${theme.palette.primary.main}`,
    fontSize: '0.8rem',
  },
  completedIcon: {
    fontSize: '1.1rem',
  },
}));

export default CustomStepIcon;
